import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { useAuth0 } from "@auth0/auth0-react";
import { mobile } from "src/utils/platformUtils";

interface GetValidYahooTokenfromBackProps {
  accessTokenFromAuth0: string;
  authId: string;
  setLoggingInTo?: (platform: string) => void;
  setTeamsdata?: (data: any) => void;
}

export const getValidYahooTokenfromBack = async ({ accessTokenFromAuth0, authId, setLoggingInTo, setTeamsdata }: GetValidYahooTokenfromBackProps): Promise<string | null> => {
  // const { user } = useAuth0();
  // const authId = user?.sub;
  console.log("🔍 Current origin:", window.location.origin);
  console.log("🔍 Current href:", window.location.href);
  const platform = mobile ? "mobile" : "web";

  try {
    // console.log("🔍 Starting getValidYahooTokenfromBack process");

    // Get the token_id from localStorage
    const tokenId = localStorage.getItem("yahoo_token_id");
    const localToken = localStorage.getItem("yahoo_token");
    console.log("📦 localToken from localStorage:", {
      exists: !!localToken,
      value: localToken ? `${localToken.substring(0, 10)}...` : "null",
    });

    // if (mobile && localToken) {
    //   console.log("✅ [MOBILE] Found token in localStorage, returning it directly:", localToken.substring(0, 10) + "...");
    //   return localToken;
    // }

    const url = `${process.env.REACT_APP_BACKEND_URL}/get-valid-yahoo-token/${authId}`;
    console.log("🔄 Trying to get token to:", url, {
      headers: {
        Authorization: `Bearer ${accessTokenFromAuth0.substring(0, 10)}...`,
      },
    });

    // console.log("🍪 [FRONTEND] Cookies being sent to backend:", {
    //   documentCookie: document.cookie,
    //   cookiesArray: document.cookie.split(";").map((c) => c.trim()),
    //   yahooTokensCookie: document.cookie.split(";").find((c) => c.includes("yahoo_tokens")),
    // });

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessTokenFromAuth0}`,
      },
      credentials: "include",
    });

    console.log("📥 Response status:", {
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Error details:", {
        status: response.status,
        statusText: response.statusText,
        errorText,
        headers: Object.fromEntries(response.headers.entries()),
      });

      return null;
    }

    const data = await response.json();

    console.log("🔄 GETVALIDYAHOOTOKEN New token obtained:", data.access_token?.substring(0, 10) + "...");

    return data.access_token;
  } catch (error) {
    console.error("❌ Unexpected error in getValidYahooTokenfromBack:", {
      error,
      message: error.message,
      stack: error.stack,
    });
    showErrorToast("Error obtaining token from Yahoo");
    return null;
  }
};
